import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';

export const cadMotoristaServices = {
  criaMotorista: (
    motorista: {
      nome: string;
      cpf: string;
      mopp: boolean;
      habilitado: string;
      telefone: string;
    },
    parceiros: number
  ): Promise<AxiosResponse> =>
    UDNICK.callService('criaAlteraMotoristaPortal', { motorista, parceiros }),
};

export const delMotoristaServices = {
  delMotorista: (codMotorista: number, parceiros: number[]): Promise<AxiosResponse> =>
    UDNICK.callService('excluiMotoristaPortal', { codMotorista, parceiros }),
};
